import { DATE_TIME_OPTIONS } from './constants';
import { IResultData, ITableRow } from './SupportHoursTypes';

export function transformFilterData(
  columnData: any[],
  mobileData: any[]
): IResultData[] {
  const result: IResultData[] = [];
  columnData.forEach(
    (column: { filterable: boolean; Header: any; accessor: any }) => {
      if (column.filterable === true) {
        const columnHeader = column.Header;
        const columnAccessor = column.accessor;

        const optionList: string[] = [];
        const transformedColumns: { option: string; selected: boolean }[] = [];

        const sortFunction = (
          itemA: { [x: string]: string },
          itemB: { [x: string]: any }
        ) => {
          return itemA[columnAccessor]?.localeCompare(
            itemB[columnAccessor],
            'en',
            {
              numeric: true,
              sensitivity: 'base',
            }
          );
        };
        const sortedMobileDataCopy = Array.from(mobileData);
        sortedMobileDataCopy.sort(sortFunction);
        const sortedDataCopy = sortedMobileDataCopy;

        sortedDataCopy.forEach((dataItem: { [x: string]: any }) => {
          dataItem[columnAccessor] &&
          typeof dataItem['original' + columnAccessor] === 'object'
            ? optionList.push(
                dataItem['original' + columnAccessor].props.children
              )
            : optionList.push(
                dataItem['original' + columnAccessor] ||
                  dataItem[columnAccessor]
              );
        });

        let uniqueOptionSet = new Set(optionList);
        uniqueOptionSet.forEach((uniqueOption) => {
          transformedColumns.push({ option: uniqueOption, selected: false }); // Set selected as boolean false
        });

        result.push({
          header: columnHeader,
          cols: transformedColumns,
          accessor: columnAccessor,
        });
      }
    }
  );

  return result;
}

export function filterData(data: any, filters: any[]) {
  let filteredData = data;

  filters.forEach((filterItem: { cols: any[]; accessor: string }) => {
    if (filterItem.cols) {
      const selectedFilterOptions = filterItem.cols
        .filter((filterOption: { selected: any }) => filterOption.selected)
        .map((filterOption: { option: any }) => filterOption.option);
      if (selectedFilterOptions.length > 0) {
        filteredData = filteredData.filter((rowItem: { [x: string]: any }) => {
          return selectedFilterOptions.includes(
            typeof rowItem['original' + filterItem.accessor] === 'object'
              ? rowItem['original' + filterItem.accessor].props.children
              : rowItem['original' + filterItem.accessor] ||
                  rowItem[filterItem.accessor]
          );
        });
      }
    }
  });
  return { filteredData };
}

export const convertUTCtoLocal = (dateString: string) => {
  const utcDate = new Date(dateString);
  return utcDate.toLocaleString('en-US', DATE_TIME_OPTIONS);
};

export const transformScheduleData = (data: any[]) => {
  function getQuarter(month: number) {
    return `Quarter ${Math.floor((month - 1) / 3) + 1}`;
  }

  return data.map((entry) => {
    const dateString = entry?.date.includes('T')
      ? entry.date
      : entry.date + 'T00:00:00Z';
    const dateObj = new Date(dateString);
    const month = dateObj.getMonth() + 1;
    const weekday = dateObj.toLocaleDateString('en-US', {
      weekday: 'long',
      timeZone: 'UTC',
    });

    const col1 = getQuarter(month);
    const col2 = dateObj.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
    const col3 = weekday;

    let col4;
    if (entry?.isClosed === 'True') {
      col4 = 'Closed';
    } else {
      const openDate = new Date(entry.openDate_UTC);
      const closeDate = new Date(entry.closedDate_UTC);

      const openTime = openDate.toLocaleTimeString('en-US', DATE_TIME_OPTIONS);
      const closeTime = closeDate.toLocaleTimeString(
        'en-US',
        DATE_TIME_OPTIONS
      );

      col4 = `${openTime} to ${closeTime}`;
    }

    return { col1, col2, col3, col4 };
  });
};

export function searchSupportHours(data: ITableRow[], searchTerm: string) {
  if (!searchTerm || searchTerm.trim() === '') {
    return data;
  }

  const lowerQuery = searchTerm.toLowerCase();
  const result = data.filter((row) =>
    Object.values(row).some(
      (value) =>
        typeof value === 'string' && value.toLowerCase().includes(lowerQuery)
    )
  );
  if (result.length === 0) {
    return data;
  }
  return result;
}
